import { buildingRoutes } from './buildings'
import { developerRoutes } from './developer'
import { routes as NEWBuildingRoutes } from './NEWBuilding'
import { routes as NEWPropertyRoutes } from './NEWProperty'
import { routes as NEWPropertyOwnershipRoutes } from './NEWProperty-ownership'
import { routes as NEWUnitRoutes } from './NEWUnit'
import { projectRoutes } from './project'
import { propertyRoutes } from './properties'
import { propertyOwnerRoutes } from './property-owner'
import { propertyOwnershipRoutes } from './property-ownership'

export const routes = {
  ...buildingRoutes,
  ...developerRoutes,
  ...projectRoutes,
  ...propertyRoutes,
  ...propertyOwnerRoutes,
  ...propertyOwnershipRoutes,
  ...NEWBuildingRoutes,
  ...NEWPropertyRoutes,
  ...NEWPropertyOwnershipRoutes,
  ...NEWUnitRoutes,
}
